import PropTypes from 'prop-types'
import React from 'react'
import PlainModal from '../../PlainModal/PlainModal.jsx'
import { isDrayNowHost } from '../../../lib/config/multitenancy.js'
import './SupportModal.scss'

const SupportModal = ({ onClose }) => {
  const isDrayNow = isDrayNowHost()
  const heading = isDrayNow ? 'DrayNow Support' : 'ModalView Support'
  const email = isDrayNow ? 'support@draynow.com' : 'support@modalview.com'

  return (
    <PlainModal
      title={heading}
      onClose={onClose}
      className='support'
      data-testid='support-modal'
    >
      <p>Contact us and speak with a real human, right away.</p>
      <p className='support-method'>
        <span className='method'>E-mail</span>
        <a href={`mailto:${email}`} data-testid='support-submit-btn'>
          {email}
        </a>
      </p>
    </PlainModal>
  )
}

SupportModal.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default SupportModal
